<template>
  <div class="mask">
    <div class="loading-box">
      <img
        class="gif-loading"
        :src="`https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/130/gif_loading.gif`"
      />
      <div class="title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadingGif",
  props: ["title"],
  components: {},
  data() {
    return {
      isShowUp: false,
      version: {},
    };
  },
  created() {},
  onLoad() {},
  methods: {},
};
</script>

<style lang="scss">
.mask {
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  margin: 0 auto;
  .loading-box {
    position: relative;
    left: 50%;
    top: 55%;
    transform: translate3d(-50%, -50%, 0);
    text-align: center;
  }
  .gif-loading {
    width: 384px;
    height: 196px;
  }
  .title {
    font-size: 19px;
    // margin:54rpx 0 0 0;
    color: #666565;
  }
}
</style>
